import { Furusato } from '@travel/icons/service';
import cx from '@travel/ui/utils/classnames';

import styles from './furusatoTaxLabel.module.scss';

type Props = {
  className?: string;
};

const FurusatoTaxLabel = ({ className = '' }: Props) => {
  return (
    <div className={cx(styles.furusatoTaxLabel, className)}>
      <Furusato size={12} className={styles.furusatoTaxIcon} />
      <span className={styles.furusatoTaxText}>ふるさと納税対象</span>
    </div>
  );
};

export default FurusatoTaxLabel;
